/* eslint-env jquery */

//import { insertCSS } from "./_css-functions.js";
import formHelp from "./_form-help.js";
import formCheckbox from "./_form-checkbox.js";

$(document).ready(function () {
  //insertCSS();
  formHelp.makeHelpButtons();
  formCheckbox.addCheckboxClickHandler();
});
